export default class FirebaseResponse {
    constructor(token = undefined, hasErrors = false, errorMessage = '') {
        this._hasErrors = hasErrors;
        this._errorMessage = errorMessage;
        this._token = token;
    }

    hasErrors() {
        return this._hasErrors;
    }

    errorMessage() {
        return this._errorMessage;
    }

    token() {
        return this._token
    }

}